// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2jNgG","detailsBorder":"styles_detailsBorder__3ylZZ"};